import { render, staticRenderFns } from "./searchArea.vue?vue&type=template&id=3228ac75&scoped=true"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"
import style0 from "./searchArea.vue?vue&type=style&index=0&id=3228ac75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228ac75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3228ac75')) {
      api.createRecord('3228ac75', component.options)
    } else {
      api.reload('3228ac75', component.options)
    }
    module.hot.accept("./searchArea.vue?vue&type=template&id=3228ac75&scoped=true", function () {
      api.rerender('3228ac75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/goodsList/components/searchArea.vue"
export default component.exports